var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaelkebakke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.167,7a.482.482,0,1,0,0,.963.573.573,0,0,1,0,1.145H8.752l-.5-1.145h1.784A.482.482,0,0,0,10.069,7l-3.52-.249c-.432-.543-1.664-.96-3.677-1.241a.48.48,0,0,0-.548.477V7.482a.481.481,0,0,0,.482.482h.821V9.109H2.37a.482.482,0,0,0,0,.964h9.8a1.536,1.536,0,0,0,0-3.072ZM4.35,7.964H7.462l.5,1.145H4.35Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaelkebakke);
export default __webpack_public_path__ + "static/media/KAELKEBAKKE.be5a32fa732ba1ae688a6c868dd52686.svg";
export { ForwardRef as ReactComponent };